import styled from "styled-components";

import colors from "core/colors";
import { ButtonLink } from "core/Typography";

export const StyledSocialLink = styled(ButtonLink)`
    &:focus {
        outline: 3px solid ${colors.functional.secondary.parrot};
    }
`;
